const _selectors = {
  addToCart: '[js-add-to-cart]',
  buyItNow: '[js-buy-it-now]',
  form: '[js-product-form]',
  loader: 'loading-spinner',
  relatedColors: '[js-related-colors]',
  productJSON: '#ProductJSON',
  zoomTriggers: '[js-zoom-trigger]',
  imageZoomModal: '[js-product-image-zoom-modal]',
  internationalMessage: '[js-international-message]',
  freeShippingMessage: '[js-free-shipping-message]'
}

const _storedVariables = {
  relatedColorsContainer: ''
}

function _getRelatedColorJSON(url) {
  return fetch(url)
    .then(response => response.text())
    .then((text) => {
      const html = text;
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      const JSONcontainer = parsedHTML.querySelector('[js-collection-json]');
      console.log('JSONcontainer', JSONcontainer)
      console.log('parsedHTML', parsedHTML)
      const parsedJSON = JSON.parse(JSONcontainer.innerHTML);
      return parsedJSON;
    })
};

_initRelatedColors()

async function _initRelatedColors() {
  _storedVariables.relatedColorsContainer = document.querySelectorAll(_selectors.relatedColors);

  if (_storedVariables.relatedColorsContainer.length < 1) {
    document.querySelector('.product__related-colors-title')?.classList.add('hidden');
    return;
  }

  const currentProductHandle = _storedVariables.relatedColorsContainer[0].getAttribute('data-handle');
  const relatedColorsTag = _storedVariables.relatedColorsContainer[0].getAttribute('data-tag');
  const targetURL = `/collections/all/${relatedColorsTag}/?view=json`;
  const relatedColorsJSON = await _getRelatedColorJSON(targetURL);
  let relatedColorsMarkup = '';

  if (relatedColorsJSON.length <= 1) {
    document.querySelector('.product__related-colors-title')?.classList.add('hidden');
    return;
  }

  relatedColorsJSON.forEach((product) => {
    if (product.handle == currentProductHandle) {
      relatedColorsMarkup = `${relatedColorsMarkup}<div class="product-related-colors__current" aria-current="true" aria-label="${product.color}"><img class="h-full w-auto mx-auto" src="${product.swatch}" alt="${product.color}"/></div>`
    }else{
      relatedColorsMarkup = `${relatedColorsMarkup}<a href="${product.url}" class="product-related-colors__related" aria-label="${product.color}"><img class="h-full w-auto mx-auto" src="${product.swatch}" alt="${product.color}" js-color-swatch-link></a>`
    }
  })

  _storedVariables.relatedColorsContainer.forEach(container => {
    container.innerHTML = relatedColorsMarkup;
    container.classList.remove('hidden');
  })

  _saveSelectedSize();
}

function _saveSelectedSize() {
  const swatchLinks = this.querySelectorAll('[js-color-swatch-link]');
  swatchLinks.forEach((link) => {
    link.addEventListener('click', () => {
      const options = this.querySelectorAll('[js-product-option-swatch]');
      const selectedOption = [...options].filter(option => option.checked);
      if (selectedOption[0]) {
        sessionStorage.setItem("savedSize", selectedOption[0].value);
      }
    })
  })
}